"use client"

import { HousePlug } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HousePlugIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HousePlugIcon = component(Icon)({ as: HousePlug })
